import { useState } from "react";

export const useKBState = () => {
    const [val, setVal] = useState({
        kb_no: "",
        llm: "",
        manual: "",
        extra: "",
        newllm: "",
        newmanual: "",
        newextra: "",
        newEnrichedData: "",
        newExtraInfo: "",
        newKB: "",
        open: false,
        called: false,
        updated: false,
        openTranscript: false,
        kb_cont: "",
        suggestions: [],
        suggestionsV: false,
        kb_list: false,
        data: [],
        // data: [
        totalRecords: 0,
        transcript: [] as any[],
        customKBdata: [],
        setKB: "",
        setResolution: "",
        setReviewer: "",
        fromDate: "",
        toDate: "",
        conversation_id: "",
        // today: moment().format('YYYY-MM-DD'),
        newCustomKB: "",
        displayUpdate: false,
        newCustomKBNo: "",
        openEditCustomKB: false,
        updatedCustomKB: "",
        setFeedback: "",
        ee: {},
        showErrorPopup: false,
        ErrorMsg: '',
        updateLoader: false,
        addKbLoader: false,
        publishloader: false,
        botIds: [],
        llm_tags: '',
        llm_utterances: '',
        getReportLoader: false,
        openPublishPopup: false

      });

    return {val, setVal};

};


